<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{name:'ExamIndex'}">在线测评</router-link>
      <span class="slash">/</span>
      <template v-if="from == 'mistake'">
        <router-link :to="{name:'MemberEvaluation', query: {tab: 'mistake'}}">错题集</router-link>
        <span class="slash">/</span>
      </template>
      <template v-else-if="from == 'collect'">
        <router-link :to="{name:'MemberEvaluation', query: {tab: 'collect'}}">收藏夹</router-link>
        <span class="slash">/</span>
      </template>
      <span class="current">{{errorCard.title}}</span>
    </div>
    <div class="main-content clearfix" v-if="total>0">
      <div class="f-left">
        <template v-if="section[index]&&this.errorCard.list.length>1">
          <div class="section-name">{{section[index].name}}</div>
          <div class="section-introduce">{{section[index].introduce}}</div>
        </template>
        <Question
          v-if="current"
          :ques="current"
          :answer="answer"
          showOperate
          @change="onChange"
          from="analysis"
          :showRemoveBtn="showRmoveBtn"
          :showJudgeBtn="showJudgeBtn"
          :showTagBtn="false"
          :showAnalysisBtn="false"
          :hasAnalysis="showAnalysis"
          :readonly="(topics.find(t=>t.question_id==current.question_id)||{}).readonly"
          @judge="onJudge"
        ></Question>
      </div>
      <div class="f-right">
        <div class="topic-nav clearfix">
          <a class="prev" :class="{'disabled':index==1}" @click="navPrev">上一题</a>
          <a class="next" :class="{'disabled':index==total}" @click="navNext">下一题</a>
        </div>
        <div class="answer-view">
          <div class="progress">
            <span class="text">答题卡</span>
            <span>
              <span class="primary-color">{{index}}</span>
              <span class="total">/{{total}}</span>
            </span>
          </div>
          <div class="legend">
            <span class="num status-1"></span>
            <span>正确</span>
            <span class="num status-2"></span>
            <span>错误</span>
            <span class="num status-3"></span>
            <span>未作答</span>
          </div>
          <div class="nums">
            <template v-if="type==2">
              <template v-for="item in errorCard.list">
                <div class="section" :key="'section-'+item.id">{{item.name}}</div>
                <div :key="'nums-'+item.id">
                  <a
                    href="javascript:void(0)"
                    class="num"
                    :class="'status-'+answerState[ques.sort]"
                    v-for="(ques, index) in item.child"
                    :key="ques.sort"
                    @click="goTo(ques.sort)"
                  >{{index + 1}}</a>
                </div>
              </template>
            </template>
            <template v-else>
              <a
                href="javascript:void(0)"
                class="num"
                :class="'status-'+answerState[key]"
                :key="key"
                v-for="(value,key) in answerState"
                @click="goTo(key)"
              >{{key}}</a>
            </template>
          </div>
        </div>
        <div class="submit" @click="onBack">返回</div>
      </div>
    </div>
  </div>
</template>
<script>
import Question from "@/components/ques/Question";
export default {
  name: "ExamWrongDo",
  components: {
    Question
  },
  data() {
    return {
      index: 1,
      answer: {},
      answerState: {},
      current: {},
      total: 0,
      type: this.$route.query.type,
      point_id: this.$route.query.point_id,
      practise_id: this.$route.query.practise_id,
      exam_id: this.$route.query.exam_id,
      topics: [],
      autoRemove: false,
      autoRemoveSet: new Set(), // 已经被自动移除的题目ID集合
      showRmoveBtn: this.$route.query.from == "collect" ? false : true, // 收藏试题不显示移除按钮
      showJudgeBtn: true,
      showAnalysis: false,
      from: this.$route.query.from,
      errorCard: {},
      section: {}
    };
  },
  async created() {
    await this.getTopicCard();
    await this.getTopic();
    await this.getAutoRemove();
  },
  methods: {
    async getTopicCard() {
      let data;
      if (this.from == "collect") {
        data = await this.$http.get("/api/app/collect/quesCard", {
          type: this.$route.query.collectType,
          type_id: this.$route.query.collectTypeID
        });
      } else {
        let params = {
          type: this.type
        };
        if (params.type == 1) {
          params.point_id = this.point_id;
        } else if (params.type == 2) {
          params.exam_id = this.exam_id;
        } else if (params.type == 3) {
          params.practise_id = this.practise_id;
        }
        data = await this.$http.post("/api/app/myExam/errorCard", params);
      }
      if (this.type == 2) {
        let topics = [];
        data.list.forEach(sec => {
          sec.child.forEach((ques, index) => {
            if (index == 0) {
              this.$set(this.section, ques.sort, {
                name: sec.name,
                introduce: sec.introduce
              });
            }
            topics.push(ques);
            this.$set(this.answerState, ques.sort, ques.status);
          });
        });
        this.topics = topics;
        this.total = topics.length;
      } else {
        data.list.forEach((t, index) => {
          t.readonly = false;
          this.$set(this.answerState, index + 1, t.status);
        });
        this.topics = data.list;
        this.total = data.list.length;
      }
      this.errorCard = data;
    },
    async getTopic() {
      if (this.index > this.topics.length) {
        return;
      }
      let data = await this.$http.post("/api/app/myExam/quesDetail", {
        ques_id: this.topics[this.index - 1].question_id
      });
      let ques = data;
      if (ques.ques_type != 5 && typeof ques.ques_option === "string") {
        ques.ques_option = JSON.parse(ques.ques_option);
      }
      ques.index = this.index;
      if (!this.answer[ques.question_id]) {
        if (ques.ques_type == 1 || ques.ques_type == 2) {
          this.$set(this.answer, ques.question_id, "");
        } else if (ques.ques_type == 3 || ques.ques_type == 4) {
          this.$set(this.answer, ques.question_id, []);
        }
      }

      this.checkDone();
      this.current = ques;
    },
    async getAutoRemove() {
      let data = await this.$http.get("/api/app/myExam/rightRemove");
      this.autoRemove = data.auto_remove_qb_wrong == 2;
    },
    checkAnswer() {
      let ques = this.current;
      let right_answer = JSON.parse(ques.right_answer);
      let rightIds = [];
      right_answer.forEach(r => {
        rightIds.push(r.id);
      });
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        this.current.user_answer = this.answer[ques.question_id].toString();
        if (this.answer[ques.question_id]) {
          if (rightIds.includes(this.answer[ques.question_id])) {
            return 1;
          } else {
            return 2;
          }
        } else {
          return 3;
        }
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        let userAnswers = this.answer[ques.question_id];
        this.current.user_answer = userAnswers.join(",");
        if (userAnswers.length > 0) {
          if (userAnswers.length == rightIds.length) {
            for (let i = 0; i < rightIds.length; i++) {
              if (!userAnswers.includes(rightIds[i])) {
                return 2;
              }
            }
            return 1;
          } else {
            return 2;
          }
        } else {
          return 3;
        }
      }
    },
    // forceDone 强行完成
    checkDone(forceDone = false) {
      if (forceDone || this.answerState[this.index] != 3) {
        this.showAnalysis = true;
        this.showJudgeBtn = false;
      } else {
        this.showAnalysis = false;
        this.showJudgeBtn = true;
      }
    },
    onChange() {
      if (this.current.ques_type == 1 || this.current.ques_type == 2) {
        this.onJudge();
      }
    },
    onJudge() {
      let status = this.checkAnswer();
      if (status != 3) {
        this.topics.find(
          t => t.question_id == this.current.question_id
        ).readonly = true;
      }
      this.$set(this.answerState, this.index, status);
      if (this.current.ques_type == 1 || this.current.ques_type == 2) {
        this.checkDone();
      } else if (this.current.ques_type == 3 || this.current.ques_type == 4) {
        this.checkDone(true);
      }
      // 处理自动定移除错题
      if (
        this.autoRemove &&
        status == 1 &&
        !this.autoRemoveSet.has(this.current.question_id)
      ) {
        this.autoRemoveSet.add(this.current.question_id);
        this.$http.post("/api/app/myExam/quesRemove", {
          ques_id: this.current.question_id
        });
      }
    },
    async navPrev() {
      if (this.index == 1) {
        return;
      }
      this.index--;
      await this.getTopic();
    },
    async navNext() {
      if (this.index == this.total) {
        return;
      }
      this.index++;
      await this.getTopic();
    },
    async goTo(index) {
      this.index = index;
      await this.getTopic();
    },
    async onBack() {
      let count = 0;
      for (let key in this.answerState) {
        if (this.answerState[key] == 3) {
          count++;
        }
      }
      let tip = "";
      if (this.from == "mistake") {
        tip = "是否结束巩固？";
        if (count > 0) {
          tip = "还有题目未做完，是否结束巩固？";
        }
      } else if (this.from == "collect") {
        tip = "是否结束练习？";
        if (count > 0) {
          tip = "还有题目未做完，是否结束练习？";
        }
      }
      await this.$promiseConfirm(tip);
      this.$router.push({
        name: "MemberEvaluation",
        query: {
          tab: this.from
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.main-content {
  margin-top: 30px;
  margin-bottom: 94px;
  > .f-left {
    width: 890px;
    background-color: white;
    border-radius: 5px;
  }
  > .f-right {
    width: 290px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 19px 20px;
    box-sizing: border-box;
  }
}
.section-name {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 1;
  padding: 21px 0 0 32px;
}
.section-introduce {
  font-size: 14px;
  color: rgba(128, 128, 128, 1);
  line-height: 1;
  padding: 20px 0 0 32px;
}
.answer-view {
  border: 1px solid rgba(237, 237, 237, 1);
  border-radius: 5px;
  margin: 20px 0;
  .progress {
    background: #e9ecec;
    padding: 0 15px 0 18px;
    font-size: 16px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    .primary-color,
    .total {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
    }
  }
  .nums {
    padding-left: 14px;
    max-height: 405px;
    overflow-y: auto;

    .section {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 12px;
    }
  }
  .num {
    width: 30px;
    height: 30px;
    border-radius: 3px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    border-radius: 3px;
    color: #333333;
    margin: 0 16px 15px 0;
    cursor: pointer;
    box-sizing: border-box;
    &.status-1 {
      background-color: #13cc59;
      color: white;
    }
    &.status-2 {
      background-color: $primary-color;
      color: white;

      &:hover {
        background: $primary-color-hover;
      }
    }
    &.status-3 {
      border: 1px solid rgba(232, 232, 232, 1);

      &:hover {
        border-color: $primary-color;
        color: $primary-color;
      }
    }
    &.status-4 {
      background-color: #bfbfbf;
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
  }
  .legend {
    padding: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    .num {
      margin: 0 6px 0 0;
      width: 14px;
      height: 14px;
      cursor: default;
    }
    span:nth-child(2) {
      margin-right: 30px;
    }
    span:nth-child(4) {
      margin-right: 28px;
    }
  }
}
.submit {
  background-color: $primary-color;
  color: white;
  border-radius: 5px;
  text-align: center;
  font-size: 16px;
  padding: 12px 0;
  cursor: pointer;
}
.topic-nav {
  display: flex;
  a {
    width: 120px;
    height: 36px;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  .prev {
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    color: rgba(51, 51, 51, 1);
    margin-right: 10px;

    &:not(.disabled):hover {
      border-color: $primary-color;
      color: $primary-color;
    }
  }
  .next {
    background: $primary-color;
    color: white;

    &:not(.disabled):hover {
      background: $primary-color-hover;
    }
  }
}
.dialog-info {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 63px;
    margin-right: 27px;
  }
}
.operate {
  font-size: 16px;
  color: #595959;
  font-weight: 400;
  padding: 30px 60px;
  > div {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .f-left img {
    margin-right: 5px;
  }
  .f-right img {
    margin-left: 5px;
  }
}
</style>
<style lang="scss">
.dialog-exam {
  width: 480px;
  box-sizing: border-box;
  padding: 35px 20px 20px 24px;
  .el-message-box__header {
    display: none;
  }
  .el-message-box__content {
    padding: 0;
    margin-bottom: 70px;
    font-size: 16px;
    color: rgba(52, 52, 52, 1);
    line-height: 1;
  }
  .el-message-box__btns {
    padding: 0;
    overflow: hidden;
  }
  .el-button {
    width: 98px;
    height: 36px;
    background: rgba(252, 86, 36, 0);
    border: 1px solid rgba(204, 204, 204, 1);
    border-radius: 3px;
    padding: 0;
    font-size: 14px;
    color: rgba(52, 52, 52, 1);

    &:nth-child(2) {
      margin-left: 14px;
    }

    &:hover {
      border-color: $primary-color;
      color: $primary-color;
    }
  }
}
.dialog-exam-progress {
  .el-button {
    float: right;

    &:nth-child(1) {
      margin-left: 14px;
      background-color: $primary-color;
      border-color: $primary-color;
      color: white;

      &:hover {
        background-color: $primary-color-hover;
        border-color: $primary-color-hover;
      }
    }
  }
}
.dialog-exam-end {
  .el-button {
    &:nth-child(2) {
      margin-left: 14px;
      background-color: $primary-color;
      border-color: $primary-color;
      color: white;

      &:hover {
        background-color: $primary-color-hover;
        border-color: $primary-color-hover;
      }
    }
  }
}
</style>